export default {
    async createFromFormData(formData) {
        let request =  {
            name: formData.name,
            employeesQuantity: formData.employeesQuantity,
            tdc1CompanyId: formData.tdc1CompanyId
        };

        if (formData.legalRepresentativeFullName) {
            request.legalRepresentativeFullName = formData.legalRepresentativeFullName;
        }

        if (formData.email) {
            request.email = formData.email;
        }

        if (formData.isPaperDueExists !== null) {
            request.isPaperDueExists = formData.isPaperDueExists;
        }

        return request;
    },
    async createEditFormData(enterprise) {
        return {
            name: enterprise.name,
            employeesQuantity: enterprise.employeesQuantity,
            isPaperDueExists: enterprise.isPaperDueExists,
        };
    },
};